import { cn } from "@/lib/cn";
import { formatMoney } from "@/lib/money";

export type MoneySize = "sm" | "md" | "lg" | "xl";

const SIZE_CLASSES: Record<MoneySize, string> = {
  sm: "text-sm",
  md: "text-base",
  lg: "text-2xl font-semibold",
  xl: "text-4xl font-bold tracking-tight",
};

export interface MoneyProps {
  /** Importe en CENTAVOS. La API nunca manda pesos con decimales. */
  cents: number;
  currency?: string;
  size?: MoneySize;
  className?: string;
}

/**
 * Muestra un importe. Siempre con cifras tabulares: si no, los números bailan
 * al actualizarse y el cajero pierde la referencia visual de la columna.
 */
export function Money({ cents, currency = "MXN", size = "md", className }: MoneyProps) {
  return (
    <span className={cn("tabular", SIZE_CLASSES[size], className)}>
      {formatMoney(cents, currency)}
    </span>
  );
}
